// @flow

import { fromJS } from 'immutable';
import * as ldClient from "launchdarkly-js-client-sdk";
import camelCase from 'lodash/camelCase';
import * as localPreferences from 'utils/localPreferences';

import store from 'store';

import { getAuthSession } from 'utils/auth/utils';
import { Config, BUILD_TYPE } from 'utils/webappConfig';
import { getLogger } from 'utils/logger';

import * as actions from './actions';
import * as defaultQuickenFlags from './flagsQuicken.json';
import * as defaultACMEFlags from './flagsACME.json';
import buildUser from './user';

const defaultFlags = process.env.PROJECT === 'acme' ? defaultACMEFlags : defaultQuickenFlags;
const log = getLogger('featureFlags/initialize');

const setFlags = (flags) => {
  const camelCasedFlags = {};
  Object.entries(flags).forEach(([key, value]) => {
    camelCasedFlags[camelCase(key)] = fromJS(value);
  });
  store.dispatch(actions.setFlags(camelCasedFlags));
};

export function initializeFeatureFlags() {
  if (!Config.builds[BUILD_TYPE].ld_client_id) {
    log.warn('Couldn\'t find ld_client_id in configuration data, so not initializing LaunchDarkly');
    return;
  }
  setFlags(defaultFlags.default);

  const authSession = getAuthSession();
  if (authSession && authSession.qcsId) {
    const user = buildUser(authSession);
    initializeLdClient(user);
  }
}

export function initializeLdClient(user) {
  if (!localPreferences.getFeatureFlagsFreeze()) {
    const options = {bootstrap: 'localStorage'};
    log.info('LaunchDarkly - Initializing with', Config.builds[BUILD_TYPE].ld_client_id, user, options);
    try {
      store.dispatch(actions.getFlags());
      window.ldClient = ldClient.initialize(Config.builds[BUILD_TYPE].ld_client_id, user, options);
      window.ldClient.on('ready', updateAllFlags);
      window.ldClient.on('change', (flags) => {
        log.info('LaunchDarkly - Received feature flags on change', flags);
        const flagsToSet = {};
        Object.entries(flags).forEach(([key, value]) => {
          // $FlowFixMe
          flagsToSet[key] = value.current;
        });
        setFlags(flagsToSet, store.dispatch);
      });
    } catch (e) {
      log.error('Exception received when initializing feature flags', e);
    }
  }
}

export function updateAllFlags() {
  const flags = window.ldClient.allFlags();
  if (Object.keys(flags).length) {
    log.info('Received feature flags on ready', flags);
    const camelCasedFlags = {};
    Object.entries(flags).forEach(([key, value]) => {
      camelCasedFlags[camelCase(key)] = fromJS(value);
    });
    store.dispatch(actions.getFlagsSuccess(camelCasedFlags));
  } else {
    log.info('No feature flags recieved on ready', flags);
    store.dispatch(actions.getFlagsFailure(Error('No feature flags recieved')));
  }
}
